// Canonical user-geometry point pin. Single source of truth shared by the
// colour carousel (the chooser) and the map renderer, so the pin the user picks
// is exactly the pin drawn on the map. Rendered at 2x (48x56) for crisp output;
// consumers downscale to 24x28 (the carousel via <img> size, the map via
// addImage `pixelRatio: 2`).
export const PIN_WIDTH = 24
export const PIN_HEIGHT = 28

// Border colour = NexDS neutralL5 (#FCFCFC). The inner circle is a real cutout
// (evenodd) so the middle of the pin is transparent (the map/card shows through).
const PIN_BORDER_COLOR = '#FCFCFC'
// The white pin would be invisible with a white border, so it uses secondaryD2.
const PIN_WHITE_COLOR = '#FCFCFC'
const PIN_WHITE_BORDER_COLOR = '#0D1012'

export const buildPinSvg = (color: string): string => {
  const borderColor = color.toUpperCase() === PIN_WHITE_COLOR ? PIN_WHITE_BORDER_COLOR : PIN_BORDER_COLOR
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="${PIN_WIDTH * 2}" height="${PIN_HEIGHT * 2}" viewBox="0 0 24 28" fill="none">` +
    `<path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C6.477 1 2 5.477 2 11c0 7 10 16 10 16s10-9 10-16c0-5.523-4.477-10-10-10zM12 7.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7z" fill="${color}" stroke="${borderColor}" stroke-width="1"/>` +
    `</svg>`
  )
}

export const pinImageDataUri = (color: string): string =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(buildPinSvg(color))}`

// Stable Mapbox image name for a given pin colour (used as `icon-image`).
export const pinImageName = (color: string): string => `ug-pin-${color.replace('#', '').toUpperCase()}`
